/**
 * Controls the auto-hiding header on scroll.
 *
 * @param {Node} document
 * @param {Object} window
 */
function autoHideHeader( document, window ) {
	'use strict';

	const elSelector = 'header';
	const element = document.querySelector( elSelector );
	const mobileMenu = document.querySelector( '[data-mobile-menu]' );
	const closeMenuOnScroll = false;

	// Bail early if no element.
	if ( ! element ) {
		throw new Error( `There is no selector '${elSelector}' to auto-hide on scroll.` );
	}

	// Set up defaults.
	let elHeight = 0;
	let dHeight = 0;
	let wHeight = 0;
	let wScrollCurrent = 0;
	let wScrollBefore = 0;
	let wScrollDiff = 0;

	window.addEventListener( 'scroll', () => {
		// Header height.
		elHeight = element.offsetHeight;

		// Document height.
		dHeight = document.body.offsetHeight;

		// Window height.
		wHeight = window.innerHeight;

		// Current y scroll position.
		wScrollCurrent = window.pageYOffset;

		wScrollDiff = wScrollBefore - wScrollCurrent;

		if ( wScrollCurrent <= 0 ) {
			// Scrolled to the very top; element sticks to the top.
			element.style.transform = 'translateY(0)';
		} else if ( wScrollDiff > 0 ) {
			// Scrolled up; element slides in.
			element.style.transform = 'translateY(0)';
		} else if ( wScrollDiff < 0 ) {
			// Scrolled down.
			if ( wScrollCurrent + wHeight >= dHeight - elHeight ) {
				// Scrolled to the very bottom; element slides in.
				// Element.style.top = ( ( elTop = wScrollCurrent + wHeight - dHeight ) < 0 ? elTop : 0 ) + 'px';
			} else {
				// Scrolled down; element slides out.
				element.style.transform = `translateY(${-elHeight}px)`;

				if ( closeMenuOnScroll ) {
					if (
						mobileMenu.getAttribute( 'data-menu-closed' ) ===
						'false'
					) {
						document.querySelector( '[data-close-menu]' ).click();
					}
				}
			}
		}
		wScrollBefore = wScrollCurrent;
	},
	{ passive: true }
	);
}

autoHideHeader( document, window );

function checkScroll( header, hero ) {
	if ( window.scrollY > hero.clientHeight ) {
		header.classList.add( 'bg-linear-gradient' );
		header.classList.remove( 'bg-pink-translucent-2' );
	} else {
		header.classList.add( 'bg-pink-translucent-2' );
		header.classList.remove( 'bg-linear-gradient' );
	}
}

function adjustHeaderGradient( header, hero ) {
	if ( header.classList.contains( 'bg-pink-translucent-2' ) ) {
		document.addEventListener( 'scroll', () => {
			checkScroll( header, hero );
		},
		{ passive: true }
		);
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	const header = document.getElementById( 'page-header' );
	const hero = document.querySelector( '.hero-background' );
	if ( hero && header ) {
		checkScroll( header, hero );
		adjustHeaderGradient( header, hero );
	}
} );
